import SelectIco from "@features/projects/assets/select-ico.svg?react";
import assignmentsStyles from '@features/assignments/styles/assignment.module.scss';
import { Icon } from "@/assets/icons";
// import { TeamsDropDown } from "@/components/dropdowns/TeamsDropDown";

export interface AssignmentHeaderProps {
  // teamselected: string;
  // setTeamSelected: (team: number) => void;
  range: {
    dateFrom: string;
    dateTo: string;
  };
}

export const AssignmentHeader = ({
  // teamselected,
  // setTeamSelected,
  range,
}: AssignmentHeaderProps) => {
  // const { TeamsDropDownComponent } = TeamsDropDown({ dropDownText: "module_users.module_drop_team" });

  return (
    <div className={assignmentsStyles["header-assignment"]}>
      <div className={assignmentsStyles["header-assignment__divHome"]}>
        <div className={assignmentsStyles["header-assignment__title-container"]}>
          <Icon name="arrowDownHome" color="#AAAAAA" />
          <p className={assignmentsStyles["header-assignment__title"]}>
            Asignaciones
          </p>
        </div>
        <div className={assignmentsStyles["header-assignment__divHomedate"]}>
          <p className={assignmentsStyles["header-assignment__date"]}>
            &nbsp;
          </p>
          <SelectIco height={"16"} />
          <div>
            <div className={assignmentsStyles["header-assignment__date--text"]}>
              <div>{range.dateFrom}</div>
              <div>{range.dateTo}</div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className={assignmentsStyles["assignment-header__inputs"]}>
        {TeamsDropDownComponent}
      </div> */}
    </div>
  );
};
